import Axios from "axios";

import { EXTRA_SMALL_SCREEN_WIDTH_MAX, MEDIUM_SCREEN_WIDTH_MAX } from "@advice/components/constants";
import { getAllowedLocationFromDMA, translateDMAString } from "@util/location";
import { getTrackingPropsAsDataAttrs } from "@util/tracking";
import { IExperimentAB } from "@util/experiment";

export interface ExperimentWindow extends Window {
    experiment: IExperimentAB;
}

declare const window: ExperimentWindow;

const getDMAFromCarmenAPI = async () => {
    // DMA: Designated Market Area
    const sessionStorageDMA = window.sessionStorage.getItem("carmen_dma");
    if (sessionStorageDMA) {
        return sessionStorageDMA;
    }
    const { data } = await Axios.get("https://carmen.themuse.com/me");
    if (data.dma) {
        window.sessionStorage.setItem("carmen_dma", data.dma);
    }
    return data.dma;
};

export const initGrowform = async () => {
    const growformUrl = "https://form.growform.co/go/621e9be70f2c290022c834ee/embedMethod/iFrame";
    /* eslint-disable max-len */
    // Try to grab the second top level div inside the article body
    let el = document.querySelector(".article-body__content-module > *:is(div,p):nth-child(2)");

    // If the second top level item isn't a div or p tag, go into the first div or p tag and get the second child
    if (!el) {
        el = document.querySelector(".article-body__content-module > *:nth-child(1):is(div,p) > *:nth-child(2):is(div,p)");
    }
    // If the second item inside the first div or p tag isn't a div or p tag, insert at the end of articles
    if (!el) {
        el = document.querySelector(".article-body__content-module > *:nth-last-child(2)");
    }
    /* eslint-enable max-len */
    const dataLayer = window.dataLayer[0];
    const assignedVariant = window.experiment.currentVariant.name;
    const isInExperiment = window.experiment.isAssignedExperiment("JOB_QUIZ_FORM") &&
                           !dataLayer.is_sponsored &&
                           assignedVariant !== "control";

    const windowWidth = window.innerWidth;
    const isMobile = (windowWidth <= EXTRA_SMALL_SCREEN_WIDTH_MAX) ? true : false;
    let placement = "2nd para desktop";
    if (isMobile) {
        placement = "2nd para mobile";
    }

    if (el) {
        let dma = null;
        let location = null;
        try {
            dma = await getDMAFromCarmenAPI();
            location = getAllowedLocationFromDMA(translateDMAString(dma));
        } catch (e) {
            console.error("Unable to fetch current location.");
            console.error(e);
        }
        const eventProps = {
            banner_type: "Job_Quiz_embed",
            click_text: isInExperiment ? "Calculate my jobs" : "",
            dma_location: (dma && isInExperiment) ? dma : null,
            experiments: [...dataLayer.experiments, window.experiment.getOskarFormat()],
            placement,
            source: "post-individual",
            used_location: (location && isInExperiment) ? location : null,
        };

        const trackingProps = {
            viewEvent: "adviceJobsBannerViewed",
            eventProps
        };
        const dataProps = getTrackingPropsAsDataAttrs(trackingProps);
        const { oskarView, oskarProps } = dataProps;
        const pageElement = document.createElement("iframe");
        pageElement.src = growformUrl;
        pageElement.id = "growform_form";
        pageElement.style.display = "block";
        pageElement.style.border = "none";
        pageElement.style.width = "100%";
        pageElement.style.minHeight = "500px";
        pageElement.setAttribute("data-oskar-view", oskarView);
        pageElement.setAttribute("data-oskar-props", oskarProps);
        el.appendChild(pageElement);

        const growformFuncs = document.createElement("script");
        /* eslint-disable max-len */
        growformFuncs.innerHTML = `
            function receiveMessage(e) {
                "growform_resize_height" == e.data.action && resizeHeight(e.data.height),
                "growform_submit_form" == e.data.action && fireSubmission(e.data.customScript),
                "growform_add_parent_gtm_container" == e.data.action && addParentGTMContainer(e.data.containerId, e.data.analyticsSettings)
            }
            function resizeHeight(e) {
                e = parseInt(e);
                e = Math.round(e) + 10,
                e += "px",
                document.getElementById("growform_form").style.height = e
            }
            function addParentGTMContainer(containerId, analyticsSettings) {
                eval(function(e, t, i, a, r) {
                    e[a] = e[a] || [],
                    e[a].push({
                        "gtm.start": (new Date).getTime(),
                        event: "gtm.js"
                    });
                    var n = t.getElementsByTagName(i)[0]
                    , o = t.createElement(i);
                    o.async = !0,
                    o.src = "https://www.googletagmanager.com/gtm.js?id=" + r,
                    n.parentNode.insertBefore(o, n)
                }(window, document, "script", "dataLayer", containerId)),
                window.dataLayer = window.dataLayer || [],
                window.dataLayer.push({
                    event: "growformAnalyticsSettings",
                    growformAnalyticsSettings: analyticsSettings
                })
            }
            function fireSubmission(customScript) {
                var existingScript = document.getElementById("customScriptPageDiv");
                if (!existingScript) {
                    var customScriptPageDiv = document.createElement("customScriptPageDiv");
                    document.body.appendChild(customScriptPageDiv),
                    customScriptPageDiv.innerHTML = customScript;
                    for (var scripts = customScriptPageDiv.getElementsByTagName("script"), i = 0; i < scripts.length; i++)
                        eval(scripts[i].innerText)
                }
            }
            window.addEventListener("message", receiveMessage, !1);
        `;
        /* eslint-enable max-len */
        el.appendChild(growformFuncs);
    }
};
